import axios from "axios";
import { AddControl, DeleteControl, EditControl, IControl } from "./modal";

// const env = import.meta.env;
// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//Fetch Control List
export const getIControlDetails = async (
  companyProfileID: number
): Promise<IControl[]> => {
  const response = await axios.get(
    `${API_BASE_URL}/api/RiskAssessment/Controls/${companyProfileID}/Details`
  );
  return response.data.data;
};

//Create Control List
export const createIControl = async (AddControl: AddControl): Promise<any> => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/RiskAssessment/Controls`,
      AddControl
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

//Update Control List
export const updateIControl = async (
  EditControl: EditControl
): Promise<any> => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/api/RiskAssessment/Controls`,
      EditControl
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

//Delete Control List
export const deleteIControl = async (
  userId: number,
  controlsID: number
): Promise<any> => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/api/RiskAssessment/Controls/${controlsID}/${userId}/Delete`
    );
    return response.data;
  } catch (error) {
    return error;
  }
};
//Delete Multiple Control List
export const deleteIControlMultiple = async (
  userId: number,
  payload: number[]

): Promise<any> => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/api/RiskAssessment/Controls/${userId}/Delete-All`, payload
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

//Import Control List
export const importControl = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/RiskAssessment/Controls/Import/Details`
    );

    // console.log("importControl res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Control Type List
export const fetchControlTypeList = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/RiskAssessment/Controls/Type/Details`
    );

    // console.log("getControlTypeDetails res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Control List
export const getImportControlList = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/RiskAssessment/Controls/Import/Details`
    );
    // console.log("getImportControlList res", res.data);

    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Import New Control
export const importNewControl = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/RiskAssessment/Controls/Import/Create`,
      payload
    );
    // console.log("importNewControl res", res.data);

    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Check Existing control
export const getExistingcontrol = async (
  companyProfileID: number,
  controlIds: number[]
) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/RiskAssessment/Cybersecurity/Control/${companyProfileID}/Exist`, controlIds
    );
    // console.log("getExistingcontrol res", res);

    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};
